import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import { Card, CardBody, CardHeader } from 'reactstrap';
import {
  cantinaObterRestricoes,
  listaEscolas,
  hideMessage,
  showAuthLoader
} from 'actions/Cantina';

import TurmaRestricaoCard from "./partials/_turmaRestricaoCard";
import IdadeRestricaoCard from "./partials/_idadeRestricaoCard";
import RestricaoAlunoCard from "./partials/_restricaoAluno";
import { selecionaModulos } from 'actions/Auth';
const styles = theme => ({

  cardWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  contentContainer: {
    width: "100%",
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(2),
  },

  card: {
    display: "flex",
    flexDirection: "column",
    height: "80vh",
    border: "1px solid #F4F4F7",
    borderRadius: 15,
    width: "100%",
  },

  cardHeader: {
    backgroundColor: "#FFFFFF",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    padding: theme.spacing(2),
  },

  headerTop: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },

  backButton: {
    color: "#0F6B5B",
  },

  cardBody: {
    flex: 1,
    overflowY: "auto",
    padding: 16,
  },

  // 🔥 agora é 1 coluna
  oneColumnGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
  }

});

class RestricaoAlimentar extends React.Component {
  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    console.log('URLSearchParams', this.props.location.search)
    const idTurma = query.get("idTurma");
    const idade = query.get("idade");
    this.props.cantinaObterRestricoes({ idTurma: idTurma, idade: idade });
  }
  handleVoltar = () => {
    this.props.history.push("/cantina");
  };

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const idTurma = query.get("idTurma");
    const idade = query.get("idade");
    const { classes } = this.props;
    return (
      <div className={classes.cardWrapper}>
        <div className={classes.contentContainer}>

          <Card className={`shadow border-0 ${classes.card}`}>

            <CardHeader className={classes.cardHeader}>

              {/* 🔥 BOTÃO VOLTAR */}
              <div className={classes.headerTop}>
                <IconButton
                  className={classes.backButton}
                  onClick={this.handleVoltar}
                >
                  <ArrowBackIcon />
                </IconButton>

                <Typography variant="h6">
                  {idTurma ? this.props.restricoes.turma : `${idade} Anos`}
                </Typography>
                <Link
                  to="/app/inicio"
                  onClick={() => this.props.selecionaModulos()}
                  style={{ textDecoration: "none" }}
                >
                  <span className="app-notification">
                    <AiFillHome size={20} style={{ color: 'silver', marginLeft: 6, marginRight: 6 }} />
                  </span>
                </Link>
              </div>

              {idTurma && (<TurmaRestricaoCard
                turma={this.props.restricoes.turma}
                totalRestricoes={this.props.restricoes.totalRestricoes}
              />)}

              {idade && (<IdadeRestricaoCard
                idade={idade}
                totalRestricoes={this.props.restricoes.totalRestricoes} />)}

            </CardHeader>

            <CardBody className={classes.cardBody}>
              <div className={classes.oneColumnGrid}>

                {this.props.restricoes.restricoes.map((aluno) => (
                  <RestricaoAlunoCard
                    key={aluno.nome}
                    nome={aluno.nome}
                    idade={aluno.idade}
                    presente={true}
                    foto={aluno.imagem}
                    restricoes={aluno.restricoes}
                  />
                ))}

              </div>
            </CardBody>

          </Card>

        </div>
      </div>
    );
  }
}

RestricaoAlimentar.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = (props) => {
  const { loader, alertMessage, showMessage, restricoes } = props.cantina;
  const { selecionarModulo } = props.auth;

  return {
    loader,
    alertMessage,
    showMessage,
    restricoes,
    selecionarModulo,
  };
};

export default connect(
  mapStateToProps,
  {
    hideMessage,
    cantinaObterRestricoes,
    listaEscolas,
    selecionaModulos,
    showAuthLoader
  }
)(withStyles(styles)(RestricaoAlimentar));